import { atom } from 'recoil';
import { Period } from './DateNavigation';

const composeAtomKey = (name: string) => `DateNavigation_${name}`;

export const dateNavigationPeriodAtom = atom<Period | null>({
  key: composeAtomKey('dateNavigationPeriod'),
  default: null
});
